import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

// Styles
import 'bootstrap';
import 'vue-toastification/dist/index.css';
import 'vue-select/dist/vue-select.css';

// Plugins
import '@/plugins/veeValidate';
import '@/plugins/fontawesome';
import '@/plugins/vueTippy';
import '@/plugins/vueToastification';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
